import { BlobProvider } from "@react-pdf/renderer";
import {
    MDBBadge,
    MDBBtn,
    MDBIcon,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalFooter,
    MDBModalHeader,
    MDBModalTitle
} from "mdb-react-ui-kit";
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { PdfContext } from "../../context/pdf/pdf-context";
import { uploadPdf } from "../../context/pdf/upload-pdf";
import { ResumeContext } from "../../context/resume/resume-context";
import { TranslationContext } from "../../context/translations/translations-context";
import useResumeDocumentSection from "../../hooks/useResumeDocumentSection";
import ResumePdf from "./ResumePdf";

function generateMailtoLink( subject, body ) {
    return `mailto:?subject=${ encodeURIComponent( subject ) }&body=${ encodeURIComponent( body ) }`;
}

export default function ResumePdfShareModal() {
    const [ isBlobReady, setIsBlobReady ] = useState( false );
    const [ isUrlReady, setIsUrlReady ] = useState( false )

    const [ show, setShow ] = useState( false );
    const [ blobProvider, setBlobProvider ] = useState( false );

    const [ pdfBlob, setPdfBlob ] = useState( null );
    const [ pdfUrl, setPdfUrl ] = useState( '' );

    const [ showBadge, setShowBadge ] = useState( false );


    const { resumeData } = useContext( ResumeContext );
    const { translations } = useContext( TranslationContext );

    const {
        state,
        finalizeShareModal,
    } = useContext( PdfContext );

    const { user } = useResumeDocumentSection();

    useEffect( () => {
        setBlobProvider( state.isShareButtonClicked && !isUrlReady );
        setShow( state.isShareButtonClicked && isUrlReady );
    }, [ state.isShareButtonClicked, isUrlReady ] );

    useEffect( () => {
        if ( isBlobReady && pdfBlob && !isUrlReady ) {
            async function uploadEffect( file, fileName, email ) {
                try {
                    return await uploadPdf( file, fileName, email );
                } catch ( err ) {
                    toast.error( err );
                }
            }

            const file = new File( [ pdfBlob ], state.pdfFileName, { type: 'application/pdf' } );
            const email = user?.email;

            uploadEffect( file, state.pdfFileName, email )
                .then( ( url ) => {
                    setPdfUrl( url );
                    setIsUrlReady( true );
                    setPdfBlob( null );
                    setIsBlobReady( false );
                } );
        }
    }, [ isBlobReady, isUrlReady, pdfBlob, state.pdfFileName, user ] );

    function copyToClipboard( text ) {
        navigator.clipboard.writeText( text ).then( () => {
            setShowBadge( true );
            setTimeout( () => {
                setShowBadge( false );
            }, 3000 );
        } );
    }

    function handleClose() {
        setIsBlobReady( false );
        setIsUrlReady( false );
        finalizeShareModal();
    }

    return (
        <>
            { blobProvider && (
                <BlobProvider
                    document={ <ResumePdf resumeData={ resumeData } translations={ translations }/> }
                >
                    { ( { blob } ) => {
                        setPdfBlob( blob );
                        setIsBlobReady( true );
                        return null;
                    } }
                </BlobProvider>
            ) }
            <MDBModal show={ show } setShow={ setShow } tabIndex="-1">
                <MDBModalDialog>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>{ translations.pdf.shareModalTitle }</MDBModalTitle>
                            <MDBBtn
                                className="btn-close"
                                color="none"
                                onClick={ handleClose }
                            ></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            { translations.pdf.shareModalBody }
                            <p>
                                { pdfUrl && (
                                    <a href={ pdfUrl } target="_blank" rel="noopener noreferrer">
                                        { pdfUrl }
                                    </a>
                                ) }
                            </p>
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn
                                style={ { background: "#97999C" } }
                                onClick={ () => copyToClipboard( pdfUrl ) }
                                position="relative"
                            >
                                { showBadge && (
                                    <MDBBadge
                                        color="info"
                                        className="position-absolute"
                                        style={ { top: "10px", right: "10px" } }
                                    >
                                        Lien copié !
                                    </MDBBadge>
                                ) }
                                <MDBIcon fas icon="copy"/> Copier
                            </MDBBtn>
                            <MDBBtn
                                style={ { background: "#09B4BF" } }
                                onClick={ () => {
                                    const body = translations.pdf.shareModalEmailBodyTemplate.replace( '{url}', pdfUrl );
                                    window.location.href = generateMailtoLink( body );
                                } }
                            >
                                <MDBIcon fas icon="link"/>Partager</MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </>
    );
}